import { gql } from 'apollo-boost';

export const turboRecomendationQuery = gql`
    query TurboRecomendationQuery(
        $login: String!
        $adsInput: GdAdsContainerInput!
    ) {
        reqId: getReqId
        client(searchBy: { login: $login }) {
            ads(input: $adsInput) {
                rowset {
                    recommendations {
                        keys {
                            userKey1
                            bid
                            type
                        }
                        ... on GdRecommendationWithKpi {
                            kpi {
                                ... on GdRecommendationKpiAddTurboWebSite {
                                    pageLoadedTimingAvg
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
